import axios from "axios";
import { useState } from "react";
import { Alert, Button, Container, Form, Table } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { AdminInstance } from "../utils/adminClass";

export const AdminReportsComponent = () => {
  const [query, setQuery] = useState("");
  const [replacements, setReplacements] = useState("");
  const [reportData, setReportData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [error, setError] = useState("");

  const handleQueryChange = (e: any) => {
    setQuery(e.target.value);
  };

  const handleReplacementsChange = (e: any) => {
    setReplacements(e.target.value);
  };

  const fetchReport = async () => {
    try {
      const replacementsObj = replacements.split(",").reduce((acc: any, item: any) => {
        const [key, value] = item.split(":").map((str: string) => str.trim());
        acc[key] = value;
        return acc;
      }, {});

      console.log("REPLACEMENTS", replacementsObj);

      const response = await AdminInstance.fetchReport(query, replacementsObj);

      console.log("response", response);
      setReportData(response[0]);
      // set the csv data
      setCsvData(response[0]);
      setError("");
    } catch (err: any) {
      setError(err.response ? err.response.data.error : err.message);
      setReportData([]);
    }
  };

  const fetchMissingBusinessLicense = async () => {
    try {
      const response = await axios.get("/api/tempfetchmissingbusinesslicense");
      setCsvData(response.data.data);
      setError("");
    } catch (err: any) {
      setError(err.response ? err.response.data.error : err.message);
      setCsvData([]);
    }
  };

  return (
    <Container>
      <h1>Admin Reports</h1>
      <Form>
        <Form.Group controlId="query">
          <Form.Label>Query</Form.Label>
          <Form.Control
            // textArea
            as="textarea"
            value={query}
            onChange={handleQueryChange}
            placeholder="Enter SQL query"
          />
        </Form.Group>

        <Form.Group controlId="replacements">
          <Form.Label>Replacements (comma-separated)</Form.Label>
          <Form.Control
            type="text"
            value={replacements}
            onChange={handleReplacementsChange}
            placeholder="Enter replacements"
          />
        </Form.Group>

        <Button variant="primary" onClick={fetchReport}>
          Fetch Report
        </Button>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}

      {reportData.length > 0 && (
        <Table striped bordered hover className="mt-4">
          <thead>
            <tr>
              {Object.keys(reportData[0]).map((key) => (
                <th key={key}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {reportData.map((row, index) => (
              <tr key={index}>
                {Object.values(row).map((value: any, i: number) => (
                  <td key={i}>{value}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <h2>Missing Business Licenses</h2>
      <Button variant="secondary" onClick={fetchMissingBusinessLicense}>
        Download CSV
      </Button>
      {csvData.length > 0 && (
        <CSVLink data={csvData} filename="missing_business_licenses.csv" className="btn btn-primary mt-3">
          Download CSV
        </CSVLink>
      )}
    </Container>
  );
};
